module.exports = __webpack_public_path__ + "img/ic-usuarios.9387d0d4.png";